<template>
  <el-dialog v-model="visible" title="编辑员工" width="800px" :before-close="handleClose">
    <el-form class="mr20" ref="ruleForm" :model="addRow" size="default" label-width="100px">
      <form-item-rule label="员工名称" prop="nickName">
        <el-input class="w500" v-model="addRow.nickName"></el-input>
      </form-item-rule>
      <form-item-rule label="手机号码" prop="mobile">
        <el-input class="w500" v-model="addRow.mobile"></el-input>
      </form-item-rule>
      <form-item-rule label="员工岗位" prop="remark">
        <el-input class="w500" v-model="addRow.remark"></el-input>
      </form-item-rule>
      <form-item-rule label="员工权限">
        <div class="role-box">
          <div class="role-item" v-for="item in personRoleAll">
            <div class="role-name">{{item.name}}</div>
            <div class="role-switch">
              <el-switch :model-value="roleList.indexOf(item.role)>-1" active-color="#7E492E" @change="changeRole($event,item)"></el-switch>
            </div>
          </div>
        </div>
      </form-item-rule>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="doSave()">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container.vue";
import FormItemRule from "@/components/el/form-item-rule.vue";

export default {
  name: "edit-person",
  components: {FormItemRule, QcContainer},
  data() {
    return {
      visible:false,
      addRow:{},
      roleList:[],
      personRoleAll: [
        {name:"门店信息",role:"0"},
        {name:"运营数据",role:"1"},
        {name:"员工管理",role:"2"},
        {name:"客户管理",role:"3"},
        {name:"订单管理",role:"4"},
        {name:"商品管理",role:"5"},
        {name:"订单核销",role:"6"},
        {name:"财务管理",role:"7"},
        {name:"售后处理",role:"8"},
        {name:"故障报修",role:"9"},
        {name:"消息管理",role:"10"},
      ]
    }
  },
  mixins: [tableBase],
  methods: {
    changeRole(event,item){
        if(event){
            this.roleList.push(item.role);
        }else{
            this.roleList.splice(this.roleList.indexOf(item.role),1);
        }
    },
    handleClose(){
      this.visible = false;
    },
    open(row) {
      if (row) {
        this.addRow = this.copyObj(row);
        this.roleList = row.ext2&&row.ext2.split(",") || [];
        this.visible = true;
      }

    },
    doSave() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
            this.addRow.ext2 = this.roleList.join(",");
          this.simplePost("/api/mgr/person/doEdit", this.addRow, () => {
            this.handleClose();
            this.$emit('load')
            this.message("操作成功");
          })
        }
      })
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
.role-box{
  display: flex;
  flex-direction: column;
  width: 500px;
}
.role-item{
  margin-top: 20rpx;
  display: flex;
  justify-content: space-between;
  .role-name{
    font-weight: 500;
    font-size: 16rpx;
    color: #333333;
  }

}
</style>
